<template>
  <div class="radar-chart-skeleton-loader">
    <apex-chart
      type="radar"
      height="350"
      :options="chartOptions"
      :series="chartSeries"
    ></apex-chart>
  </div>
</template>

<script>
import ApexChart from 'vue-apexcharts';
import { random } from 'lodash';

export default {
  name: 'RadarChartSkeletonLoader',

  data() {
    return {
      chartSeries: this.generateChartSeries(),
    };
  },

  methods: {
    /**
     * Generate a random chart series.
     *
     * @returns {{data: number[], name: string}[]}
     */
    generateChartSeries() {
      return [
        {
          name: 'Series 1',
          data: Array(7).fill('').map(() => random(1, 20)),
        },
      ];
    },
  },

  computed: {
    chartOptions() {
      return {
        chart: {
          height: window.screen.availHeight > 768 ? 350 : 300,
          toolbar: {
            show: false,
          },
        },
        stroke: {
          width: 3,
          curve: 'smooth',
        },
        fill: {
          opacity: 0.7,
        },
        colors: ['#DDDBDD'],
        markers: {
          size: 6,
          colors: ['#fff'],
          strokeColor: '#DDDBDD',
          strokeWidth: 3,
        },
        xaxis: {
          categories: ['▬▬▬▬▬', '▬▬▬▬▬', '▬▬▬▬▬', '▬▬▬▬▬', '▬▬▬▬▬', '▬▬▬▬▬', '▬▬▬▬▬'],
          style: {
            cssClass: 'chart-xaxis-label',
          },
        },
        yaxis: {
          show: false,
        },
        tooltip: {
          enabled: false,
        },
      };
    },
  },

  mounted() {
    this.intervalGenerateChartSeries = setInterval(() => {
      this.chartSeries = this.generateChartSeries();
    }, 2000);
  },

  beforeDestroy() {
    clearInterval(this.intervalGenerateChartSeries);
  },

  components: {
    ApexChart,
  },
};
</script>

<style lang="scss" scoped>
.radar-chart-skeleton-loader {
  &:after {
    @apply absolute;
    @apply top-0;
    @apply right-0;
    @apply bottom-0;
    @apply left-0;
    transform: translateX(-100%);
    background-image: linear-gradient(90deg, rgba(#fff, 0) 0, rgba(#fff, 0.2) 20%, rgba(#fff, 0.5) 60%, rgba(#fff, 0));
    animation: skeleton-loader 3s infinite;
    content: '';
  }
}
</style>
